export const CONSULTAR_KEY_CAPTCHA = "@recepcion-documental/CONSULTAR_KEY_CAPTCHA";
export const KEY_CAPTCHA_CONSULTADA = "@recepcion-documental/KEY_CAPTCHA_CONSULTADA";
export const ERROR_CONSULTANDO_KEY_CAPTCHA = "@recepcion-documental/ERROR_CONSULTANDO_KEY_CAPTCHA";

export const LIMPIAR_STATE_SEGURIDAD = "@recepcion-documental/LIMPIAR_STATE_SEGURIDAD";
